import app from './app';

// german
export default {
  app,
};
